import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../navigation.service';
import { getAppHref } from 'navigation/nav-shared/utils/link.utils';

@Component({
  selector: 'nav-site-logo',
  template: `
    <ng-container [ngSwitch]="currentThemeMode">
      <ng-container *ngSwitchCase="'default'">
        <a
          class="site-logo__link"
          title="Go to the Avery homepage"
          [href]="homeLinkUrl"
        >
          <svg
            class="site-logo"
            aria-label="Avery"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            viewBox="0 0 97.75 46.23"
          >
            <title>Avery</title>
            <defs>
              <style>
                .blue {
                  fill: #0039a6;
                }
                .red {
                  fill: #de1d37;
                }
              </style>
            </defs>
            <polygon
              class="blue"
              points="92.19 14.47 87.89 21.91 83.58 14.47 78.19 14.47 85.18 26.58 82.29 31.58 87.68 31.58 97.58 14.47 92.19 14.47"
            />
            <path
              class="blue"
              d="M70.46,22.64h-5v-4.1h5c1.59,0,2.56.678,2.56,2C73.02,21.753,72.129,22.64,70.46,22.64Zm7.3-2.29h0a5.328,5.328,0,0,0-1.51-4c-1.15-1.17-3-1.86-5.56-1.86H60.75V31.58h4.73v-5.2h3.94l3.47,5.2h5.46l-4.1-6A5.387,5.387,0,0,0,77.76,20.35Z"
            />
            <polygon
              class="red"
              points="8.16 30.57 10.5 46.23 50.72 40.22 49.71 33.47 47.38 33.47 48.09 38.27 12.45 43.6 10.5 30.57 8.16 30.57"
            />
            <polygon
              class="blue"
              points="46.55 24.81 54.72 24.81 54.72 21.08 46.55 21.08 46.55 18.49 57.15 18.49 57.15 14.47 41.86 14.47 41.86 31.58 57.27 31.58 57.27 27.55 46.55 27.55 46.55 24.81"
            />
            <polygon
              class="blue"
              points="29.77 25.18 24.32 14.47 18.85 14.47 27.55 31.58 31.99 31.58 40.69 14.47 35.22 14.47 29.77 25.18"
            />
            <path
              class="blue"
              d="M11.54,19.88L14.22,25H8.87ZM9,14.47L0,31.58H5.38l1.55-2.94h9.23l1.55,2.94h5.38l-9-17.11H9Z"
            />
            <polygon
              class="red"
              points="44.71 0 4.49 6.01 6 16.07 7.31 13.57 7.82 12.62 7.12 7.95 42.77 2.63 44.25 12.54 46.58 12.54 44.71 0"
            />
          </svg>
        </a>
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./site-logo.component.scss'],
})
export class SiteLogoComponent implements OnInit, OnDestroy {
  currentThemeMode: string = 'default';
  subscriptions: Subscription[] = [];
  homeLinkUrl: string;
  constructor(private navigationService: NavigationService) {}

  ngOnInit() {
    this.subscriptions = [this.themeModeSubscription()];
    this.homeLinkUrl = getAppHref('/');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * get the current theme mode
   *
   * @returns {subscription}
   * @memberof SiteLogoComponent
   */
  themeModeSubscription() {
    return this.navigationService.themeMode.subscribe((value) => {
      this.currentThemeMode = value;
    });
  }
}
